"use client";

import { CategoryIcon } from "@commerce-frontend/ui/base/CategoryIcon/CategoryIcon";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { Link } from "@commerce-frontend/ui/base/Link/Link";
import { DialogClose } from "@commerce-frontend/ui/components/Dialog/Dialog";
import type { IconName } from "@commerce-frontend/ui/icon";
import { cn } from "@commerce-frontend/ui/utils/classNames";
import { createCategoryCrumbsHash } from "@commerce-shared/url";
import { usePathname } from "next/navigation";

type Props = {
	label: string;
	link: { url: string; alternativeCrumbs?: string[] };
	categoryIcon?: string | null;
	icon?: IconName;
};

export const MenuItemLink = ({ label, link, categoryIcon, icon }: Props) => {
	const pathname = usePathname();

	return (
		<DialogClose asChild>
			<Link
				href={{
					pathname: link.url,
					...(link.alternativeCrumbs
						? {
								query: {
									cr: createCategoryCrumbsHash(link.alternativeCrumbs),
								},
							}
						: {}),
				}}
				rel={link.alternativeCrumbs ? "nofollow" : undefined}
				className={cn(
					"flex items-center gap-2 rounded-none border-b border-border py-4 text-sm text-blue-300",
					pathname === link.url && "font-bold text-main",
				)}
			>
				{categoryIcon && (
					<CategoryIcon
						iconName={categoryIcon}
						iconSize="24"
						className="bg-main"
					/>
				)}

				{icon && <Icon icon={icon} className="bg-main" />}

				{label}
			</Link>
		</DialogClose>
	);
};
